import shortly from 'vuex-shortly'
import { TODO_BRANDS, TODO_CREATE, NOTIFICATIONS_INCLUDE } from '@store/types'
import axios from 'axios'
import graphQL from '@graphQL'
import TodoGiftsProducts from '@graphQL/queries/TodoGiftsProducts'
import orderArrayByAttribute from '@helpers/orderArrayByAttribute'
import router from '@/router'

const state = {
  todoBrands: []
}

const getters = {
  [TODO_BRANDS]: 'todoBrands'
}

const mutations = {
  [TODO_BRANDS]: (state, payload) => {
    state.todoBrands = payload
  }
}
const actions = {
  [TODO_BRANDS]: ({ commit }, payload) => {
    return graphQL(TodoGiftsProducts).then(response => {
      if (response.data.data.todoGiftsProducts) {
        const orderedTodoGiftsProducts = orderArrayByAttribute(response.data.data.todoGiftsProducts, 'brand_name')
        commit(TODO_BRANDS, orderedTodoGiftsProducts)
      }
    })
  },
  [TODO_CREATE]: async ({ dispatch }, payload) => {
    try {
      await axios.post('/giftcards/bulk-buy-todo', payload)
        .then(response => {
          dispatch(NOTIFICATIONS_INCLUDE, {
            type: 'success',
            message: 'Gift Cards comprados com sucesso!'
          })
          router.push({name: 'Clientes'})

          return response
        }).catch(error => {
          const errorMessage = error.response.status === 403 ? 'Você não tem permissão para realizar esta ação!' : 'Ocorreu um erro!'

          dispatch(NOTIFICATIONS_INCLUDE, Error(errorMessage))
          return error
        })
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Ocorreu um erro!'))
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/todo.js